import * as STD        from '@emersya/mpa-std';
/* app reference is autoloaded */
declare global {
	const disableBaseAppEngineComponentAutoRun: boolean;
	const app: components.Application.Component;
	let MPAEngineCustomApp: typeof components.Application.Component | undefined;

	interface Window {
		app: components.Application.Component;
		disableBaseAppEngineComponentAutoRun: boolean;
		MPAEngineCustomApp?: typeof components.Application.Component | undefined;
		readonly MPAEngineNS: {
			readonly components: typeof components;
			readonly EngineModule: typeof EngineModule;
		};
	}
}
declare var app: components.Application.Component;
import './onlyForAppStyles.scss';
import * as components from './components';
import EngineModule    from './EngineModule';


(<STD.object.SetWritable<typeof window, 'MPAEngineNS'>>window).MPAEngineNS = {
	components,
	EngineModule: EngineModule
};
if (!window.disableBaseAppEngineComponentAutoRun) {
	if (window.MPAEngineCustomApp) {
		await window.MPAEngineCustomApp.run();
	} else {
		await components.Application.Component.run();

	}
}
export *               from './components';
